const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlephium(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 955 955",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M383.439,627.578c0,-12.321 -9.737,-20.618 -21.765,-18.497l-143.765,25.346c-12.028,2.12 -21.765,13.851 -21.765,26.171l-0,271.864c-0,12.348 9.737,20.645 21.765,18.525l143.765,-25.346c12.028,-2.121 21.765,-13.851 21.765,-26.2l0,-271.863Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M758.023,18.828c-0,-12.321 -9.737,-20.618 -21.765,-18.497l-143.766,25.346c-12.028,2.12 -21.765,13.851 -21.765,26.171l0,271.864c0,12.348 9.737,20.645 21.765,18.525l143.766,-25.346c12.028,-2.121 21.765,-13.851 21.765,-26.2l-0,-271.863Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M406.641,82.425c-5.553,-12.23 -20.479,-20.287 -33.366,-18.015l-154.034,27.156c-12.887,2.272 -18.826,14.008 -13.274,26.238l341.087,751.231c5.553,12.23 20.511,20.358 33.398,18.086l154.034,-27.156c12.888,-2.273 18.795,-14.079 13.242,-26.309l-341.087,-751.231Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlephium);
export default __webpack_public_path__ + "static/media/alephium.b6b7164339264abce9777a4bc6f9c5f9.svg";
export { ForwardRef as ReactComponent };